import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@mdi/font/css/materialdesignicons.css'
import VueI18n from 'vue-i18n'
import { messages, defaultLocale } from '@/i18n'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueI18n)

const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-GB',
  silentFallbackWarn: true
})

Vue.use(VueGtag, {
  enabled: process.env.VUE_APP_GTAG_ENABLED,
  config: {
    id: process.env.VUE_APP_GA,
    params: {
      user_id: store.state.user.username
    }
  }
})

const app = new Vue({
  router,
  store,
  icons,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

// Set user properties
app.$gtag.set({
  user_properties: { ...store.state.user, crm_id: store.state.user.username }
})

router.afterEach((to) => {
  // Save in GA4 the user navigation
  app.$gtag.pageview({
    page_title: to.name?.toString(),
    page_path: to.fullPath,
    page_location: window.location.toString()
  })
})
